// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"38d1ab00d57aaf40011c","339":"7f221ea7883c89c5de86"}[chunkId] + ".js";
};